import { createAccessControl } from "better-auth/plugins/access";
import {
  defaultStatements as adminDefaultStatements,
  adminAc,
  userAc,
} from "better-auth/plugins/admin/access";
import {
  ownerAc as orgOwnerAc,
  adminAc as orgAdminAc,
  memberAc as orgMemberAc,
  defaultStatements as orgDefaultStatements,
} from "better-auth/plugins/organization/access";

const statement = {
  ...adminDefaultStatements,
  ...orgDefaultStatements,
  admin_canViewAll: ["true"],
  org_canViewPage: [
    "settings",
    "dashboard",
    "drillManagement",
    "persona",
    "scenario",
    "history",
  ],
  org_drill: ["create", "assignement"],
  org_persona: ["create"],
  org_scenario: ["create"],
} as const;

export const ac = createAccessControl(statement);

export const admin_admin = ac.newRole({
  ...adminAc.statements,
  admin_canViewAll: ["true"],
});
export const admin_user = ac.newRole({
  ...userAc.statements,
});

export const org_owner = ac.newRole({
  ...orgOwnerAc.statements, // Permissions par défaut pour gérer les membres, invitations, etc.
  org_canViewPage: [
    "settings",
    "dashboard",
    "drillManagement",
    "persona",
    "scenario",
    "history",
  ],
  org_drill: ["create", "assignement"],
  org_persona: ["create"],
  org_scenario: ["create"],
});

export const org_admin = ac.newRole({
  ...orgAdminAc.statements, // Permissions par défaut pour gérer les membres, invitations, etc.
  org_canViewPage: [
    "settings",
    "dashboard",
    "drillManagement",
    "persona",
    "scenario",
    "history",
  ],
  org_drill: ["create", "assignement"],
  org_persona: ["create"],
  org_scenario: ["create"],
});

export const org_enabler = ac.newRole({
  org_canViewPage: [
    "dashboard",
    "drillManagement",
    "persona",
    "scenario",
    "history",
  ],
  org_drill: ["create", "assignement"],
  org_persona: ["create"],
  org_scenario: ["create"],
});

export const org_team_manager = ac.newRole({
  org_canViewPage: ["dashboard", "history"],
});

export const org_user = ac.newRole({
  ...orgMemberAc.statements,
  org_canViewPage: ["history"],
});
